import { AppBar, Grid, Tab, Tabs } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import Dialog from "../../../dialog";
import Loading from "../../../loading";
import SnackbarComponent from "../../../snackbar";
import WorkingDaysComponent from "../../workingDaysComponent";
import Fanpage from "./fanpage";
import Feature from "./feature";
import Information from "./information";
import QRCode from "./qrCodeComponent";
import Setting from "./serviceSetting";

import { styles } from "./styles";

class ServiceDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      service: {
        name: "",
        website: "",
        phone: "",
        mobile: "",
        support: [],
        minPrice: "",
        maxPrice: "",
        address: "",
        district: "",
        city: "",
      },
      data: {},
      tab: 0,
    };
  }

  handleChangeTab = (event, value) => {
    this.setState({ tab: value });
  };

  handleSubmit = async (payload = {}) => {
    this.loading.startLoading();

    const { t } = this.props;
    let { data = {}, typeUpdate } = this.state;
    data = { ...data, ...payload };

    if (
      data &&
      data.service &&
      data.service.support &&
      typeof data.service.support !== "string"
    ) {
      data.service.support = JSON.stringify(data.service.support);
    }

    let check =
      typeUpdate === "information"
        ? await this.props.serviceDispatch.updateServiceForOwner({
          data: data.service,
        })
        : typeUpdate === "workingHours"
          ? await this.props.serviceDispatch.updateWorkingHours({ data: data })
          : typeUpdate === "feature"
            ? await this.props.serviceFeatureDispatch.updateFeature({ data: data })
            : typeUpdate === "function"
              ? await this.props.serviceFunctionDispatch.updateFunction({
                data: data,
              })
              : typeUpdate === "setting"
                ? await this.props.updateServiceSetting({ data: data })
                : 0;
    this.loading.stopLoading();

    if (check.code === 1) {
      this.mSnackbar.handleClick(
        t("service_ownerspa_servicedetail_update_successfully")
      );
    } else {
      if (typeUpdate === "feature" || typeUpdate === "function") {
        this.mFeature.backupValue(typeUpdate);
      }
      this.mSnackbar.handleClick(
        t("service_ownerspa_servicedetail_update_unsuccessfully") +
        " " +
        check.message,
        "error"
      );
    }
  };
  handleUpdate = (typeUpdate, data) => {
    let _this = this;
    this.setState({ typeUpdate: typeUpdate, data: data }, function () {
      // _this.mDialog.handleUpdate()
      _this.handleSubmit();
    });
  };
  componentDidMount = () => {
    if (
      this.mSnackbar &&
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.pushNoti
    )
      this.mSnackbar.handleClick(this.props.location.state.pushNoti);
    this.setState({ service: this.props.service || {} });
  };
  componentWillReceiveProps(nextProps) {
    if (
      this.mSnackbar &&
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.pushNoti
    )
      this.mSnackbar.handleClick(this.props.location.state.pushNoti);
    if (nextProps.service !== this.props.service) {
      this.setState({ service: nextProps.service || {} });
    }
  }
  handleSnackbar = (message, type) => {
    this.mSnackbar.handleClick(message, type);
  };
  render() {
    const { classes, t, disabled = false } = this.props;
    const { tab, service = {} } = this.state;
    if (service !== undefined && service !== "" && service !== null) {
      service.imageUrl = service.imageUrl || "/images/noneImage.svg";
      return (
        <div className={classes.root}>
          <SnackbarComponent
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
          <Loading onRef={(id) => (this.loading = id)} />
          <AppBar position="static" color="default" className={classes.appTabs}>
            <Tabs
              value={tab}
              onChange={this.handleChangeTab}
              indicatorColor="secondary"
              classes={{
                root: classes.tabsRoot,
                indicator: classes.tabsIndicator,
              }}
              scrollButtons="on"
              variant="scrollable"
              scrollButtons="on"
              variant="scrollable"
            >
              <Tab
                label={t("service_ownerspa_servicedetail_information")}
                classes={{
                  root: classes.tabRoot,
                  textColorPrimary: classes.textColorPrimary,
                  selected: classes.selected,
                }}
              />
              <Tab
                label={t("service_ownerspa_servicedetail_working_hours")}
                classes={{
                  root: classes.tabRoot,
                  textColorPrimary: classes.textColorPrimary,
                  selected: classes.selected,
                }}
              />
              <Tab
                label={t("service_ownerspa_servicedetail_feature_and_function")}
                classes={{
                  root: classes.tabRoot,
                  textColorPrimary: classes.textColorPrimary,
                  selected: classes.selected,
                }}
              />
              <Tab
                label={t("service_ownerspa_servicedetail_qr_and_bar_code")}
                classes={{
                  root: classes.tabRoot,
                  textColorPrimary: classes.textColorPrimary,
                  selected: classes.selected,
                }}
              />
              <Tab
                label="Fanpage"
                classes={{
                  root: classes.tabRoot,
                  textColorPrimary: classes.textColorPrimary,
                  selected: classes.selected,
                }}
              />
              <Tab
                label={t(
                  "service_ownerspa_servicedetail_service_setting_settings"
                )}
                classes={{
                  root: classes.tabRoot,
                  textColorPrimary: classes.textColorPrimary,
                  selected: classes.selected,
                }}
              />
            </Tabs>
          </AppBar>

          {tab === 0 && (
            <div className={classes.container}>
              <Information
                disabled={disabled}
                handleSubComponentChange={this.handleSubComponentChange}
                service={service}
                onRef={(info) => (this.mInformation = info)}
                handleUpdate={this.handleUpdate}
                handleSubmit={this.handleSubmit}
              />
            </div>
          )}
          {tab === 1 && (
            <div className={classes.container}>
              <WorkingDaysComponent
                service={service}
                disabled={disabled}
                onRef={(id) => (this.WorkingDays = id)}
                handleSubComponentChange={this.handleSubComponentChange}
                handleUpdate={this.handleUpdate}
                handleSubmit={this.handleSubmit}
              />
            </div>
          )}
          {tab === 2 && (
            <div>
              <Feature
                service={service}
                disabled={disabled}
                onRef={(feature) => (this.mFeature = feature)}
                handleUpdate={this.handleUpdate}
                handleSubmit={this.handleSubmit}
              />
            </div>
          )}
          {tab === 3 && (
            <div className={classes.container}>
              <QRCode
                service={service}
                disabled={disabled}
                handleSnackbar={this.handleSnackbar}
              />
            </div>
          )}
          {tab === 4 && (
            <div className={classes.container}>
              <Fanpage service={service} disabled={disabled} />
            </div>
          )}
          {tab === 5 && (
            <div className={classes.container}>
              <Setting
                service={service}
                disabled={disabled}
                handleUpdate={this.handleUpdate}
                handleSubmit={this.handleSubmit}
              />
            </div>
          )}
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

ServiceDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  serviceDispatch: dispatch.service,
  serviceFeatureDispatch: dispatch.serviceFeature,
  serviceFunctionDispatch: dispatch.serviceFunction,
  updateServiceSetting: dispatch.serviceSetting.updateServiceSetting,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ServiceDetail)
  )
);
